import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import {
    Component,
    input,
    model,
    OnInit,
    output,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';
import { Icon } from '../icon/icon.component';

export type TableItem = {
    id?: string;
    description?: string;
    value?: any;
    type?: string;
    tooltip?: string;
};

export type TableHeaderElement = {
    name: string;
    value: string;
    sort?: 'asc' | 'desc' | '';
    sortable?: boolean;
};

/**
 * @deprecated
 * Preferir a utilização do componente DataTable.
 *
 */
@Component({
    selector: 'ai-table',
    imports: [NgFor, NgTemplateOutlet, Icon, NgIf],
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    // Estiliza o conteúdo via seletores globais `ai-table ...` (o host recebe
    // `_nghost`, então selectors `ai-table ...` não casariam sob Emulated). Igual
    // ao `ai-datatable`.
    encapsulation: ViewEncapsulation.None,
})
export class Table implements OnInit {
    /** Colunas/cabeçalho da tabela (two-way via `model`). */
    header = model<TableHeaderElement[]>([] as TableHeaderElement[]);
    /** Linhas da tabela (matriz de células). */
    rows = input<TableItem[][]>([] as TableItem[][]);
    /** Template opcional para renderizar cada célula. */
    itemTemplate = input<TemplateRef<any> | undefined>();
    /** Emite o cabeçalho da coluna ao ordenar. */
    sortColumnClicked = output<TableHeaderElement>();

    ngOnInit(): void {
        this.header.set(this.header().map((item) => ({ ...item, sort: '' })));
    }

    protected onClickSortColumn(
        headerItem: TableHeaderElement,
        direction: 'asc' | 'desc' | '',
    ): void {
        if (headerItem.sort === direction) {
            direction = '';
        }

        headerItem.sort = direction;

        this.header.set(
            this.header().map((item) =>
                item.value === headerItem.value
                    ? { ...item, sort: direction }
                    : item,
            ),
        );

        this.sortColumnClicked.emit(headerItem as TableHeaderElement);
    }
}

/** Rodapé da {@link Table}, projetado abaixo das linhas. */
@Component({
    selector: 'ai-table-footer',
    imports: [],
    template: '<ng-content></ng-content>',
})
export class TableFooter {}
